<template>
    <sections>
        <section-title
            v-bind="{
                heading: 'CONTACT',
                content: '<p>Get in contact with ' + $config.public.siteName + '</p>',
            }"
        ></section-title>
        <section-text-columns
            v-bind="{
                contentColumn1: '<article-contact-text-left />',
                contentColumn2: '<article-contact-text-right />',
            }"
        ></section-text-columns>
        <section-cards
            v-bind="{
                color: 'bg-zinc-900',
                heading: 'USEFUL NUMBERS',
                content:
                    'If you are worried that you might be at risk from lock snapping or lock bumping, then you may want to contact your local Police force for more information.',
                cards: [
                    {
                        heading: 'Kirkburton Crime Reduction',
                        excerpt: '<p>Dave Whitteron<br>Mark Wall<br>01484 436839<br>01484 436840</p>',
                    },
                    {
                        heading: 'Dewsbury Crime Reduction',
                        excerpt: '<p>John Ellis<br>Steve Blakeley<br>Roger Day<br>01924 431041<br>01924 431048</p>',
                    },
                    {
                        heading: 'Kirkburton Crime Reduction',
                        excerpt:
                            '<p>Call ' +
                            $config.public.companyTelephone +
                            '</p><p>Stephen Allen<br>4 Taylor Street<br>Golcar<br>Huddersfield<br>HD7 4BR</p>',
                    },
                ],
            }"
        ></section-cards>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: 'Get in contact with ' + $config.public.siteName + '.',
    index: true,
});
</script>
